module.exports = __webpack_public_path__ + "static/media/person2.433403d2.png";